export const iconFontAwesomeFilesFileCircleXmark = (
	<i className="fa-solid fa-file-circle-xmark"></i>
);
